import { Modal, Button } from "react-bootstrap";
import { X } from "react-bootstrap-icons";
import ExtratoConteudoV2, { type ExtratoConteudoV2Props } from "../ExtratoConteudoV2/ExtratoConteudoV2";

export type ModalExtractVisualizacaoV2Props = Omit<ExtratoConteudoV2Props, "showPageHeader" | "disabled"> & {
  show: boolean;
  onClose: () => void;
  onSolicitarConfirmacaoEnvio: () => void;
};

const ModalExtractVisualizacaoV2 = ({
  show,
  onClose,
  onSolicitarConfirmacaoEnvio,
  ...extratoProps
}: ModalExtractVisualizacaoV2Props) => (
  <Modal
    show={show}
    onHide={onClose}
    centered
    size="xl"
    contentClassName="modal-extract-custom"
    style={{ border: "1px solid #D9D9D9", borderRadius: "12px" }}
  >
    <Modal.Header>
      <Modal.Title style={{ color: "#005ca9", fontWeight: "bold" }}>
        EXTRATO
      </Modal.Title>
      <Button
        variant="link"
        onClick={onClose}
        style={{ color: "#005ca9", fontSize: 32, marginRight: -10, marginTop: -10 }}
        className="p-0 ms-auto"
        aria-label="Fechar"
      >
        <X />
      </Button>
    </Modal.Header>

    <Modal.Body>
      <div
        className="v2-pdf-generating v2-extract-container"
        style={{
          maxHeight: "60vh",
          overflowY: "auto",
          overflowX: "hidden",
          border: "1px solid #D9D9D9",
          borderRadius: "8px",
        }}
      >
        <ExtratoConteudoV2
          {...extratoProps}
          showPageHeader={false}
          disabled={true}
        />
      </div>
    </Modal.Body>

    <Modal.Footer className="justify-content-center gap-3">
      <Button
        onClick={onClose}
        style={{
          minWidth: "140px",
          background: "white",
          border: "1px solid #005ca9",
          color: "#005ca9",
        }}
      >
        CANCELAR
      </Button>
      <Button
        onClick={onSolicitarConfirmacaoEnvio}
        style={{
          minWidth: "140px",
          background: "#005ca9",
          border: "1px solid #005ca9",
          color: "white",
        }}
      >
        ENVIAR
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalExtractVisualizacaoV2;
